import { GET_PROJECT_SETTINGS_SUCCESS } from "../../../reducers/dashboardReducer";
import { setCurrentProject } from "../../../utils/projectUtils";

export const getProjectDetailsSuccess = (project) => {
  setCurrentProject(project, false); // Don't update URL here since it should already be correct
  return {
    type: GET_PROJECT_SETTINGS_SUCCESS,
    payload: { project },
  };
};
